import Constants from '@usas/ui-web/utils/Constants';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitAthleteEntryIndividualRosterEntryByOmeMeetOrgUnitEntryIdData from './GetOrgUnitAthleteEntryIndividualRosterEntryByOmeMeetOrgUnitEntryIdData';
import getOrgUnitAthleteEntryIndividualRosterEntryByOrgUnitAthleteEntryIdData from './GetOrgUnitAthleteEntryIndividualRosterEntryByOrgUnitAthleteEntryIdData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  omeMeetOrgUnitEntryId: Constants.DEFAULT_ID
};

const OmeMeetOrgUnitAthleteEntryIndividualRosterEntryData = {
  INITIAL_STATE,
  getOrgUnitAthleteEntryIndividualRosterEntryByOmeMeetOrgUnitEntryIdData,
  getOrgUnitAthleteEntryIndividualRosterEntryByOrgUnitAthleteEntryIdData
}

export default OmeMeetOrgUnitAthleteEntryIndividualRosterEntryData;